// import swal from 'sweetalert2'
// import Vue from 'vue'
import sas from 'surfandscan'
// import $ from 'jquery'
import Vue from 'vue'

/**
 * Vue.prototype.$sasExt
 * @type {{loadExamQuestions: BaseApi.loadExamQuestions, loadExams: BaseApi.loadExams, hideIdle: BaseApi.hideIdle, loadParticipants: BaseApi.loadParticipants, archiveStats: BaseApi.archiveStats, setCredentials: BaseApi.setCredentials, checkCredentials: BaseApi.checkCredentials, loadSurveys: BaseApi.loadSurveys, removeUser: BaseApi.removeUser, resetCredentials: BaseApi.resetCredentials, loadQuestions: BaseApi.loadQuestions, loadSystemGroupList: BaseApi.loadSystemGroupList, loadExam: BaseApi.loadExam, boolValueOfExam: BaseApi.boolValueOfExam, downloadExamRankList: BaseApi.downloadExamRankList, loadHistory: BaseApi.loadHistory, calculateExam: BaseApi.calculateExam, downloadExamPointList: BaseApi.downloadExamPointList, loadTests: BaseApi.loadTests, saveSystemGroupRights: BaseApi.saveSystemGroupRights, loadQuestion: BaseApi.loadQuestion, loadParticipantsWithAnswers: BaseApi.loadParticipantsWithAnswers, onGetError: BaseApi.onGetError, loadStats: BaseApi.loadStats, showIdle: BaseApi.showIdle, loadGroup: BaseApi.loadGroup, downloadExamGroupList: BaseApi.downloadExamGroupList, downloadExamNotesAsExcel: BaseApi.downloadExamNotesAsExcel, loadSystemGroupRights: BaseApi.loadSystemGroupRights}}
 */
const BaseApi = {
  pluginConfig: {
    pluginName: 'examenis',
    xereaderPath: 'c:\\tools\\eReaderX\\',
    ereaderPath: 'C:\\work\\edologic\\ereader\\bin',
    dataPath: 'c:\\tools\\eReaderX\\data\\'
  },

  uploadFilesToExamFolder: function (params, fnSuccess, fnError) {
    var credits = Vue.prototype.$api.getCredentials()
    var headers = {
      'Authorization': credits.authToken,
      'username': credits.data.username
    }
    params.groupFiles = ''
    params.docType = 'jpg'
    params.uploadTo = Vue.prototype.$config.EXAM_HOST + '/v2/exam/uploadScan/' + params.examId + '?upload=true&docType=jpg&groupFiles=&&x=1'

    sas.uploadTaskToDestination(params, headers, fnSuccess, fnError)
  },
  moveFilesToExamFolder: function (params, fnSuccess, fnError) {
    console.log('moveFilesToExamFolder ' + params.taskId + ' to ' + params.uploadTo)

    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/examenis/v1/moveFiles',
      data: params,
      type: 'GET',

      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },

  getTaskStatus: function (taskId, fnSuccess, fnError) {
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/scantask/status',
      data: {
        taskId: taskId

      },
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'GET',

      headers: {
        'xes_api_key': this.API_KEY
      },
      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },

  scan: function (scannerId, isDuplex, dpi, fnSuccess, fnError) {
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/scanImage',
      // Tell jQuery we're expecting JSONP
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      data: {
        scannerId: scannerId,
        duplex: isDuplex,
        dpi: dpi
      },
      type: 'GET',

      headers: {
        'xes_api_key': this.API_KEY
      },
      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },
  writePluginConfiguration: function (config, fnSuccess, fnError) {
    config['action'] = 'write'
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/pluginConfig?pluginName=' + this.pluginConfig.pluginName,
      data: config,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      headers: {
        'xes_api_key': this.API_EDO_DATA
      },

      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },

  /**
   *
   * @param fnSuccess
   * @param fnError
   */
  getPluginConfiguration: function (fnSuccess, fnError) {
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/pluginConfig?pluginName=' + this.pluginConfig.pluginName,
      type: 'GET',
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      headers: {
        'xes_api_key': this.API_EDO_DATA
      },

      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },
  getConfiguration: function (fnSuccess, fnError) {
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/config',
      type: 'GET',

      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      headers: {
        'xes_api_key': this.API_EDO_DATA
      },

      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },
  getScanFolderFiles (id, fnSuccess, fnError) {
    var param = {
      taskId: 'hello',
      folder: 'data\\' + id + '\\scans'
    }
    var url = sas.gbl_host + '/examenis/v1/list'
    Vue.prototype.$api.getJQuery().ajax({
      url: url,
      data: param,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      type: 'GET',

      headers: {
        'xes_api_key': 'examenis'
      },

      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)
        }
      }
    })
  },
  createRecogJob (id, recognizeAllNew, fnSuccess, fnError) {
    var params = {
      'examId': id
    }
    if (recognizeAllNew) {
      params['jobType'] = 'createRecog'
    } else {
      params['jobType'] = ''
    }

    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/examenis/v1/createJob',
      data: params,
      type: 'GET',

      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,

      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)

          fnError(xhr, status, error)
        }
      }
    })
  },
  clearScanFolder (id, fnSuccess, fnError) {
    var params = {
      'taskId': '0815',
      'examId': id
    }
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/examenis/v1/emptyFiles',
      data: params,
      type: 'GET',
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,

      success: function (data) {
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)

          fnError(xhr, status, error)
        }
      }
    })
  },
  startProcess (id, fnSuccess, fnError) {
    var config = {
      'exeName': this.pluginConfig.ereaderPath + '\\eReader.exe',
      'param1': '',
      'param2': ''
    }
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/examenis/v1/startProcess',
      type: 'GET',
      data: config,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      headers: {
        'xes_api_key': this.API_EDO_DATA
      },
      success: function (data) {
        console.log(data)
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)

          fnError(xhr, status, error)
        }
      }
    })
  },
  startRecognize (id, fnSuccess, fnError) {
    var config = {
      'exeName': this.pluginConfig.ereaderPath + '\\eReader.exe',
      'param1': 'onlyreco',
      'param2': ''
    }
    Vue.prototype.$api.getJQuery().ajax({
      url: sas.gbl_host + '/examenis/v1/startProcess',
      type: 'GET',
      data: config,
      dataType: 'jsonp',
      contentType: 'application/json; charset=utf-8;',
      async: false,
      crossDomain: true,
      headers: {
        'xes_api_key': this.API_EDO_DATA
      },
      success: function (data) {
        console.log(data)
        if (fnSuccess) {
          fnSuccess(data)
        }
      },
      error: function (xhr, status, error) {
        if (fnError) {
          fnError(xhr, status, error)
        } else {
          console.log('error')
          console.log(xhr)
          console.log(status)
          console.log(error)

          fnError(xhr, status, error)
        }
      }
    })
  }
}
export default BaseApi



// WEBPACK FOOTER //
// ./src/sasExt.js